export const MIN_FILTER_LENGTH = 3;
export const DEFAULT_PLACEHOLDER = "Type to search...";
export const MIN_CHAR_MESSAGE = "Type more characters to search";
export const NO_RESULTS_MESSAGE = "No results found";
